import { IAppState } from '../../types'
import {
  FETCHING_NEWS,
  ERROR_NEWS,
  UPDATE_NEWS,
  FETCHING_GROUPS,
  ERROR_GROUPS,
  UPDATE_GROUPS,
  FETCHING_MATCHES,
  ERROR_MATCHES,
  UPDATE_MATCHES,
  FETCHING_SCHEDULE,
  ERROR_SCHEDULE,
  UPDATE_SCHEDULE,
  FETCHING_CLIPS_AND_PLAYLISTS,
  ERROR_CLIPS_AND_PLAYLISTS,
  UPDATE_CLIPS_AND_PLAYLISTS,
  FETCHING_STATES
} from '../constants/data'

import { sleep } from '../../lib/promise-utils'
import {
  safelyFetchNews,
  safelyFetchSchedule,
  safelyFetchGroups,
  safelyFetchMatch,
  safelyFetchRefetch,
  safelyFetchClipsAndPlaylists
} from './lib/fetches'

const fetchNews = () => async (dispatch, getState: () => IAppState) => {
  const { data, general } = getState()
  const { status } = data.news

  if (status === FETCHING_STATES.FETCHING) return

  dispatch({ type: FETCHING_NEWS })
  try {
    const { urls } = general
    const { newsUrl } = urls

    const news = await safelyFetchNews(newsUrl)

    return dispatch({ type: UPDATE_NEWS, news })
  } catch (err) {
    console.log('error', err)

    dispatch({ type: ERROR_NEWS })
  }
}

const fetchSchedule = () => async (dispatch, getState: () => IAppState) => {
  const { data, general } = getState()
  const { schedule } = data
  const { urls } = general
  const { scheduleUrl } = general.urls

  const { status } = schedule

  if (status === FETCHING_STATES.FETCHING) return
  dispatch({ type: FETCHING_SCHEDULE })

  try {
    const matches = await safelyFetchSchedule(scheduleUrl)
    return dispatch({ type: UPDATE_SCHEDULE, data: matches })
  } catch (err) {
    console.log('error', err)
    dispatch({ type: ERROR_SCHEDULE })
  }
}

const fetchGroups = () => async (dispatch, getState: () => IAppState) => {
  const { data, general } = getState()
  const { groups } = data
  const { status } = groups

  const { urls } = general
  const { groupsUrl } = urls

  if (status === FETCHING_STATES.FETCHING) return

  dispatch({ type: FETCHING_GROUPS })
  try {
    const groups = await safelyFetchGroups(groupsUrl)

    return dispatch({ type: UPDATE_GROUPS, groups })
  } catch (err) {
    console.log('error', err)

    dispatch({ type: ERROR_GROUPS })
  }
}

const fetchMatch = id => async (dispatch, getState: () => IAppState) => {
  const { data, general } = getState()
  const { matches } = data
  const { urls } = general
  const { matchUrl } = urls

  if (matches[id] && matches[id].status === FETCHING_STATES.FETCHING) {
    return
  }

  dispatch({ type: FETCHING_MATCHES, id })
  try {
    const match = await safelyFetchMatch(`${matchUrl}/${id}`)

    return dispatch({ type: UPDATE_MATCHES, match, id })
  } catch (err) {
    console.log('error', err)

    dispatch({ type: ERROR_MATCHES, id })
  }
}

const refetch = (id: string, delay: number = 15000) => async (
  dispatch,
  getState: () => IAppState
) => {
  await sleep(23000)
  const { data, general } = getState()
  const { matches, schedule } = data
  const { urls } = general
  const { refetchUrl } = urls

  if (
    schedule.status === FETCHING_STATES.FETCHING &&
    matches[id] &&
    matches[id].status === FETCHING_STATES.FETCHING
  ) {
    return
  }

  dispatch({ type: FETCHING_MATCHES, id })
  dispatch({ type: FETCHING_SCHEDULE })
  try {
    const { match, scheduleMatches } = await safelyFetchRefetch(
      `${refetchUrl}/${id}`
    )

    dispatch({ type: UPDATE_MATCHES, match, id })
    dispatch({ type: UPDATE_SCHEDULE, data: scheduleMatches })
  } catch (err) {
    console.log('error', err)

    dispatch({ type: ERROR_MATCHES, id })
    dispatch({ type: ERROR_SCHEDULE, id })
  }
}

const fetchClipsAndPlaylists = () => async (
  dispatch,
  getState: () => IAppState
) => {
  const { data, general } = getState()

  const { playlists } = data
  const { status } = playlists

  const { urls } = general
  const { clipsandplaylistsUrl } = urls

  if (status === FETCHING_STATES.FETCHING) return

  dispatch({ type: FETCHING_CLIPS_AND_PLAYLISTS })
  try {
    const { playlists, clips } = await safelyFetchClipsAndPlaylists(
      clipsandplaylistsUrl
    )

    return dispatch({ type: UPDATE_CLIPS_AND_PLAYLISTS, playlists, clips })
  } catch (err) {
    console.log('error', err)

    dispatch({ type: ERROR_CLIPS_AND_PLAYLISTS })
  }
}

export {
  fetchNews,
  fetchSchedule,
  fetchMatch,
  fetchGroups,
  refetch,
  fetchClipsAndPlaylists
}
